export const RiskQuizResultsContent = {
  pageTitle: `Your risk attitude is: `,
};
